<template>
	<div class="home">
		<div class="display-message">
			<img :src="getLogoUrl(charging)" alt="">
			<h2>{{message}}</h2>
      <router-link v-if="retry" class="retry-link" :to="{name: 'charging', params: {sale, charging, id: charging.code}}">{{translation.home.tryAgain}}</router-link>
		</div>
	</div>
</template>

<script>
import { translate } from '../../assets/translations';
import { getLogoUrl } from '../../utils';

export default {
  props: ['message', 'sale', 'charging', 'retry'],
	computed: {
    translation() {
      return translate(this.charging.language);
    },
  },
	methods: {
		getLogoUrl,
	}
}
</script>

<style scoped lang="scss">
.home {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 50px;
}

.display-message {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 700px;
	height: 500px;
	background: white;
	border-radius: 20px;
	img {
		height: 100px;
		margin-bottom: 100px;
	}
}

.retry-link {
  margin-top: 20px;
  font-size: 1.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ChargingFeedback.vue